import { useEffect, useState } from "react";
import { getFileDownloadUrl } from "../../../../../api/firebase/firestoreService";
import { CmmOrderTableRowData } from "../../../../../data-model/cmmOrderTableRowData";
import { ErrorState, LoadingState, MedicationHeader } from "./ui";

interface AsteraImageTabProps {
  identifier: string;
  rowData?: CmmOrderTableRowData;
}

const AsteraImageTab = ({ identifier, rowData }: AsteraImageTabProps) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!identifier) {
      setError("No identifier available");
      setLoading(false);
      return;
    }

    const filePath = `astera/${identifier}.png`;
    setLoading(true);
    setError(null);

    getFileDownloadUrl(filePath)
      .then((url) => {
        setImageUrl(url);
      })
      .catch(() => {
        setError("Failed to load image");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [identifier]);

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-2 border-1 border-primaryGray-15 bg-[#F7F9FA]">
      <MedicationHeader data={rowData as CmmOrderTableRowData} />
      {loading ? (
        <div className="flex h-full w-full flex-row items-center justify-center gap-2 p-8">
          <LoadingState message="Loading Astera image..." />
        </div>
      ) : error || !imageUrl ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-8">
          <ErrorState message={error ?? "Image not found"} />
        </div>
      ) : (
        <div className="m-1 flex min-h-0 w-full flex-1 items-center justify-center overflow-auto p-4">
          <img
            src={imageUrl}
            className="block min-w-0 max-w-none shrink-0"
            alt={`Astera`}
          />
        </div>
      )}
    </div>
  );
};

export default AsteraImageTab;
